import React, { useEffect, useState } from "react";
import DashboardLayout from "Layout/DashboardLayout";
import DashboardCards from "./Components/DashboardCards";
import TopSellingProducts from "./Components/TopSellingProducts";
import NewOrders from "./Components/NewOrders";
import SalesOverviewGraph from "./Components/SalesOverviewGraph";
import { DatePicker, Dropdown, MenuProps } from "antd";
import { Icon } from "@iconify-icon/react";
import dayjs, { Dayjs } from "dayjs";

const Dashboard = () => {
  const [timePeriod, setTimePeriod] = useState(() => {
    return localStorage.getItem("timePeriod") || "year";
  });

  const [customStartDate, setCustomStartDate] = useState<string>("");
  const [customEndDate, setCustomEndDate] = useState<string>("");

  useEffect(() => {
    localStorage.setItem("timePeriod", timePeriod);
  }, [timePeriod]);

  const items: MenuProps["items"] = [
    {
      label: "Day",
      key: "0",
      onClick: () => {
        setTimePeriod("day");
        setCustomStartDate("");
        setCustomEndDate("");
      },
    },
    { type: "divider" },
    {
      label: "Week",
      key: "1",
      onClick: () => {
        setTimePeriod("week");
        setCustomStartDate("");
        setCustomEndDate("");
      },
    },
    { type: "divider" },
    {
      label: "Month",
      key: "3",
      onClick: () => {
        setTimePeriod("month");
        setCustomStartDate("");
        setCustomEndDate("");
      },
    },
    { type: "divider" },
    {
      label: "Year",
      key: "4",
      onClick: () => {
        setTimePeriod("year");
        setCustomStartDate("");
        setCustomEndDate("");
      },
    },
    { type: "divider" },
    // {
    //   label: "Custom",
    //   key: "5",
    //   onClick: () => setTimePeriod("custom"),
    // },
  ];

  const { RangePicker } = DatePicker;
  const isStartDateValid = dayjs(customStartDate).isValid();
  const isEndDateValid = dayjs(customEndDate).isValid();

  return (
    <DashboardLayout title="Dashboard" back={false}>
      <div className="flex justify-end pr-[40px] mt-[20px]">
        <div className="flex items-center gap-2">
          <RangePicker
            value={[
              customStartDate ? dayjs(customStartDate) : null,
              customEndDate ? dayjs(customEndDate) : null,
            ]}
            onCalendarChange={(dates) => {
              if (dates) {
                setCustomStartDate(
                  dates[0]?.format("YYYY-MM-DDTHH:mm:ss") || ""
                );
                setCustomEndDate(dates[1]?.format("YYYY-MM-DDTHH:mm:ss") || "");
                setTimePeriod("custom");
              }
            }}
            format="YYYY-MM-DD HH:mm:ss"
          />

          <Dropdown menu={{ items: items }} trigger={["click"]}>
            <div
              onClick={(e) => e.preventDefault()}
              className="p-2 cursor-pointer text-[12px] bg-white flex justify-between items-center border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            >
              {timePeriod}
              <Icon
                icon="iconamoon:arrow-down-2-duotone"
                width={20}
                color="#474747"
              />
            </div>
          </Dropdown>
          {/* {timePeriod === "custom" && (
            <div>
              <RangePicker
                value={selectedDates}
                showTime
                onCalendarChange={(dates, dateStrings) => {
                  if (dates && dateStrings[0] && dateStrings[1]) {
                    const startDate = dateStrings[0];
                    const endDate = dateStrings[1];
                    setPayload({ startDate: startDate, endDate: endDate });
                    setSelectedDates(dates);
                  } else {
                    setSelectedDates(null);
                    setPayload({ startDate: "", endDate: "" });
                  }
                }}
              />
            </div>
          )} */}
        </div>
      </div>
      <div className="px-[20px] py-[20px]">
        <DashboardCards
          timePeriod={timePeriod}
          customStartDate={customStartDate}
          customEndDate={customEndDate}
        />
        <div className="flex gap-4 mt-4">
          <div className="w-6/12">
            <SalesOverviewGraph timePeriod={timePeriod} />
          </div>
          <div className="w-6/12">
            <TopSellingProducts timePeriod={timePeriod} />
          </div>
        </div>
        <NewOrders />
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
